"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const malty_atoms_icon_wrapper_1 = require("@carlsberggroup/malty.atoms.icon-wrapper");
const react_1 = __importDefault(require("react"));
const Italic = (props) => (0, malty_atoms_icon_wrapper_1.IconWrapper)(props, react_1.default.createElement("path", { d: "M16.002 5a1 1 0 01.116 1.993L16.003 7H13.83l-1.662 10h1.815a1 1 0 01.116 1.993l-.116.007H7.998a1 1 0 01-.116-1.993L7.997 17h2.147l1.662-10h-1.79a1 1 0 01-.116-1.993L10.017 5z", fillRule: "evenodd" }));
exports.default = Italic;
//# sourceMappingURL=index.js.map